import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/AllTransaction/Table";
import DeleteModal from "../../Components/AllTransaction/DeleteModal";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import EditTransactionModel from "../../Components/Transactions/EditTransactions";
import ViewDetailModel from "../../Components/Transactions/ViewDetails";
import moment from "moment";
import { useLocation } from "react-router-dom";
import SideModal from "../../Components/SideModal";
import { IoFilter } from "react-icons/io5";
import FilterModal from "../../Components/FilterModals/TransactionFilterModal";

const AllTransactions = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const location = useLocation();
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [advancedFilter, setAdvancedFilter] = useState("");
  // const [filter, setFilter] = useState("phone");

  const [option, setOption] = useState("phone");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(1, "days").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );

  const { t } = useTranslation();

  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(1, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
    option: "phone",
  };

  const fetchFunction = async () => {
    const body = new FormData();

    body.append("startDate", startDate);
    body.append("endDate", endDate);
    // body.append("filterType", option);
    // body.append("filterValue", filterValue);
    if (advancedFilter && advancedFilter.startsWith("MODE_")) {
      body.append("filterType", "mode");
      body.append("filterValue", advancedFilter.replace("MODE_", ""));
    } else {
      body.append("filterType", option);
      body.append("filterValue", filterValue);
    }
    return await axios.post(`${Config.apiUrl}/alltransactions`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const {
    isLoading,
    mutate: getTransactionMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {});

  useEffect(() => {
    const handler = setTimeout(() => {
      getTransactionMutate();
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate, option, advancedFilter]);

  // const submitHandler = (values) => {
  //   const newValues = {
  //     startDate: moment(values.startDate).format("YYYY-MM-DD"),
  //     endDate: moment(values.endDate).format("YYYY-MM-DD"),
  //   };
  //   setStartDate(newValues.startDate);
  //   setEndDate(newValues.endDate);
  //   getTransactionMutate();
  // };

  // const ChangeHandler = (e) => {
  //   setFilterValue(e.target.value);
  // };

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getTransactionMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
    if (advancedFilter.startsWith("MODE_")) {
      setAdvancedFilter("");
    }
  };

  //------- Edit Single Entry -------
  const EditTransactionFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("status", values.status);
    return await axios.post(`${Config.apiUrl}/edittransaction`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditEntrySuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");

      getTransactionMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditUser(false);
  };
  const onEditEntryError = (data) => {
    setEditUser(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };
  const { isLoading: editEntryLoading, mutate: editComplaintsMutate } =
    useMutation(EditTransactionFunction, {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    });

  const deleteFunction = async (tenantId) => {
    const body = new FormData();
    body.append("tenantId", selectedData.tenantId);
    body.append("referenceId", selectedData.ledgerReferenceId);
    return await axios.post(`${Config.apiUrl}/resettransaction`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onDeleteSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Deleted Successfully");
      setDeleteModal(false);
      getTransactionMutate();
    }
  };

  const onDeleteError = (res) => {};

  const { isLoading: isDeleteLoading, mutate: deleteMutate } = useMutation(
    deleteFunction,
    {
      onSuccess: onDeleteSuccess,
      onError: onDeleteError,
    },
  );

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Transaction")}
                <span>{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
          </div>
          <SideModal
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
          >
            <FilterModal
              handleClose={() => setIsFilterOpen(false)}
              onApplyFilter={(value) => {
                setAdvancedFilter(value);
                setIsFilterOpen(false);
              }}
              handleClearFilters={() => {
                setAdvancedFilter("");
              }}
              currentFilter={{ value: advancedFilter }}
            />
          </SideModal>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              // setFilter={setFilter}
              option={option}
              setOption={setOption}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              t={t}
              setIsFilterOpen={setIsFilterOpen}
              setAdvancedFilter={setAdvancedFilter}
            />
          </div>
          {deleteModal && (
            <DeleteModal
              deleteMutate={deleteMutate}
              isDeleteLoading={isDeleteLoading}
              setDeleteModal={setDeleteModal}
              selectedData={selectedData}
            />
          )}
          {editUser && (
            <EditTransactionModel
              editComplaintsMutate={editComplaintsMutate}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}
          {viewDetail && (
            <ViewDetailModel
              setViewDetail={setViewDetail}
              selectedData={selectedData}
            />
          )}

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={error ? [] : data?.data?.data}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                userType={user.userType}
                setDeleteModal={setDeleteModal}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};
const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  filter,
  // setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
  option,
  setOption,
  setIsFilterOpen,
  setAdvancedFilter,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    class="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    class="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>
          <div className="flex gap-3 items-end flex-wrap">
            {/* {filter !== "status" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{("")}</Label>
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  class="ml-1"
                  value={filterValue}
                  onChange={ChangeHandler}
                  className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2"
                />
              </InputGroup>
            ) : filter === "status" ? (
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                >
                  <MenuItem value="1">{t("PENDING")}</MenuItem>
                  <MenuItem value="2">{t("SUCCESS")}</MenuItem>
                  <MenuItem value="3">{t("FAILED")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null} */}
            {option !== "status" && option !== "gateway" ? (
              <InputGroup className="w-[200px]">
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  value={filterValue}
                  onChange={ChangeHandler}
                  className="border border-gray-300 rounded-md px-3 h-10 w-full focus:ring-1 focus:ring-primary-color focus:border-primary-color"
                />
              </InputGroup>
            ) : option === "status" ? (
              <InputGroup className="w-[120px]">
                <Select
                  value={filterValue}
                  onChange={ChangeHandler}
                  style={{ height: "40px" }}
                  className="h-10 w-full px-2"
                >
                  <MenuItem value="1">PENDING</MenuItem>
                  <MenuItem value="2">SUCCESS</MenuItem>
                  <MenuItem value="3">FAILED</MenuItem>
                </Select>
              </InputGroup>
            ) : option === "gateway" ? (
              <InputGroup className="w-[140px]">
                <Select
                  value={filterValue}
                  onChange={ChangeHandler}
                  style={{ height: "40px" }}
                  className="h-10 w-full px-2"
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Gateway
                  </MenuItem>
                  <MenuItem value="1">PAYU</MenuItem>
                  <MenuItem value="2">Cashfree</MenuItem>
                  <MenuItem value="3">Easebuzz</MenuItem>
                </Select>
              </InputGroup>
            ) : null}
            <InputGroup className="" style={{ flexBasis: "content" }}>
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                id="option"
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={option}
                onChange={(e) => {
                  // set
                  // console.log("filter inside values is :", option);
                  setOption(e.target.value);
                  setFilterValue("");
                }}
              >
                <MenuItem value="phone">Phone</MenuItem>
                <MenuItem value="clientName">Client Name</MenuItem>
                <MenuItem value="property">Property </MenuItem>
                <MenuItem value="recordedBy">Recorded By </MenuItem>
                <MenuItem value="gateway">Gateway</MenuItem>
              </Select>
            </InputGroup>
            <button
              type="button"
              onClick={() => setIsFilterOpen(true)}
              className="h-10 w-10 flex items-center justify-center border border-gray-300 rounded-md bg-white hover:bg-gray-100"
            >
              <IoFilter size={18} />
            </button>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};
const TableWrapper = tw.h1`my-10 border  bg-white rounded-md`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
export default AllTransactions;
